import { Injectable } from '@angular/core';
import {AngularFireFunctions} from '@angular/fire/compat/functions';
import {Observable} from 'rxjs';

export interface UserSearchResult {
  gId: string;
  name: string;
  primaryEmail: string;
  orgUnitPath?: string;
  thumbnailPhotoUrl?: string;
  schools?: any[];
}

@Injectable({
  providedIn: 'root'
})
export class StudentsService {

  static defaultPhotoUrl = 'https://ssl.gstatic.com/images/branding/product/1x/avatar_circle_blue_512dp.png';
  private customerId: string;
  constructor(private angularFireFunctions: AngularFireFunctions) {

  }

  setCustomerId(customerId: string): void {
    this.customerId = customerId;
  }

  findStudentsByList(list: string[]): Observable<{data: UserSearchResult[]; count: number}> {
    return this.angularFireFunctions.httpsCallable('students-findStudents')({
      customerId: this.customerId,
      list
    });
  }

  searchForStudents(term: string): Observable<{data: UserSearchResult[]; count: number}> {
    return this.angularFireFunctions.httpsCallable('students-findStudents')({
      customerId: this.customerId,
      term
    });
  }

  findUsersByPattern(pattern: string): Observable<{data: UserSearchResult[]; count: number}> {
    return this.angularFireFunctions.httpsCallable('students-findByPattern')({
      customerId: this.customerId,
      pattern
    });
  }
}
